module.exports = __webpack_public_path__ + "static/media/400280_02.f79f1c2d.png";